import { ThermometerChevronDownIcon } from './ThermometerChevronDownIcon';

/**
 * author: Michael Richins
 * id C888E2C1-306A-4BCB-821E-5B33AC93572D
 * name thermometer-chevron-down
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer-chevron-down.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const ThermometerDecreaseIcon = ThermometerChevronDownIcon;
export default ThermometerDecreaseIcon